import React, { useEffect, useMemo } from 'react';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import { LoaderMi, Bouton, GroupeBouton } from '@design-system-etat/dsfr-react';
import { connect } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import { getDateFRFromYYYYMMDDHHMMSS } from 'components/Commun/Form/Date/dateTranformation';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import usagerClientReducer from '../../../store/usagerReducer';
import RoutesVisualiserCeaf from '../mes-demarches/ceaf/visualiser/routes';
import {
    API_CEAF_GENERATION_PDF,
    API_POST_CEAF_RECUPERER_DERNIERE_EDITEE,
    CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE,
    CONTEXT_CEAF_GENERATION_PDF,
} from '../../../constants/apiUrls.constants';
import {
    INFOS_CEAF_PDF,
    MIME_APPLICATION_OCTET_STREAM,
    MIME_APPLICATION_PDF,
} from '../../../constants/fileConstant';
import MesAutorisations from '../mes-demarches/components/mesAutorisations/MesAutorisations';
import { getPath } from '../../../utils/router';

// TODO: Ne pas oublier de mettre en place la gestion des rôles dans le back quand elle sera implémentée
// TODO: Cette partie est inaccessible pour les chasseurs
const MesTitresDeDetention = ({
    getApi,
    reinitialiseApi,
    dataDerniereCeafEditee,
    isLoadingDerniereCeafEditee,
    dataCeafPdfBase64,
    isLoadingCeafPdfBase64,
}) => {
    const {
        statut: statutCeaf,
        dateExpiration: dateExpirationCeaf,
        uuid: uuidCeaf,
        numeroCeaf,
        dateInit: dateInitCeaf,
    } = dataDerniereCeafEditee || {};

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_POST_CEAF_RECUPERER_DERNIERE_EDITEE,
            CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE,
        );

        return () => {
            reinitialiseApi(CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE);
        };
    }, []);

    const urlVisualiserCeaf = getPath(RoutesVisualiserCeaf, {
        uuidCeaf: dataDerniereCeafEditee ? uuidCeaf : null,
    });

    const genererPdfCeaf = () => {
        if (dataDerniereCeafEditee) {
            getApi(
                usagerClientReducer,
                API_CEAF_GENERATION_PDF + uuidCeaf,
                CONTEXT_CEAF_GENERATION_PDF,
            );
        }
    };

    const getActionsCeaf = () => {
        return (
            <GroupeBouton isHorizontal alignementHorizontal="center">
                <Link className="fr-nav" to={urlVisualiserCeaf}>
                    <Bouton label="Visualiser" icone="fr-fi-eye-line" niveau="secondaire" />
                </Link>
                <BoutonFichierTelechargeable
                    handleOnClick={genererPdfCeaf}
                    label="Télécharger ma CEAF"
                    isLoading={isLoadingCeafPdfBase64}
                    titreFichier={INFOS_CEAF_PDF}
                    mimeType={MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM}
                    contenu={dataCeafPdfBase64}
                    iconOnly
                />
            </GroupeBouton>
        );
    };

    const donneeCeaf = useMemo(() => {
        if (dataDerniereCeafEditee) {
            return [
                numeroCeaf,
                statutCeaf,
                getDateFRFromYYYYMMDDHHMMSS(dateInitCeaf),
                statutCeaf === 'Valide' ? getDateFRFromYYYYMMDDHHMMSS(dateExpirationCeaf) : '-',
                getActionsCeaf(),
            ];
        }
        return [];
    }, [dataDerniereCeafEditee, dataCeafPdfBase64, isLoadingCeafPdfBase64]);

    const titresCarteEuropeenneArmesFeu = [
        'N° de la carte',
        'Statut',
        'Date de délivrance',
        "Date d'expiration",
        'Actions',
    ];

    return (
        <div className="margin-bottom-lg">
            <h1>Mes titres de détention</h1>
            <br />
            <h2 className="font-size-lg margin-top-sm">Ma carte européenne d&apos;armes à feu</h2>

            <div className="position-relative" style={{ minHeight: '130px' }}>
                {isLoadingDerniereCeafEditee && <LoaderMi taille="md" />}
                {!isLoadingDerniereCeafEditee && (
                    <SimpleTable
                        entete={titresCarteEuropeenneArmesFeu}
                        donnees={[donneeCeaf]}
                        boutonActionsPresent
                    />
                )}
                {!isLoadingDerniereCeafEditee && !dataDerniereCeafEditee && (
                    <div className="margin-bottom-md -margin-top-sm" hidden={false}>
                        Aucune CEAF n&apos;a encore été éditée
                    </div>
                )}
            </div>

            <br />
            <h2 className="font-size-lg margin-top-xs">Mes autorisations</h2>
            <MesAutorisations />
        </div>
    );
};

MesTitresDeDetention.propTypes = {
    reinitialiseApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    dataDerniereCeafEditee: PropTypes.shape({
        statut: PropTypes.string.isRequired,
        dateExpiration: PropTypes.string.isRequired,
        uuid: PropTypes.string.isRequired,
        numeroCeaf: PropTypes.string.isRequired,
        dateInit: PropTypes.string.isRequired,
    }),
    isLoadingDerniereCeafEditee: PropTypes.bool,
    dataCeafPdfBase64: PropTypes.object,
    isLoadingCeafPdfBase64: PropTypes.bool,
};

export default connect(
    (state) => {
        const { data: dataDerniereCeafEditee, isLoading: isLoadingDerniereCeafEditee } =
            state.ceaf.recuperDerniereEditee;

        const { data: dataCeafPdfBase64, isLoading: isLoadingCeafPdfBase64 } =
            state.ceaf.fichierPdfBase64;

        return {
            dataDerniereCeafEditee,
            isLoadingDerniereCeafEditee,
            dataCeafPdfBase64,
            isLoadingCeafPdfBase64,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(MesTitresDeDetention);
